import { debounce } from "@/utils/helpers";
import { locales } from "@blocknote/core";
import "@blocknote/core/fonts/inter.css";
import { useCreateBlockNote } from "@blocknote/react";
import { BlockNoteView } from "@blocknote/mantine";
import "@blocknote/mantine/style.css";

import { useCallback, useEffect, useState } from "react";
import "@/styles/text-editor-style.css";
import { editorTheme } from "@/features/proposal/editor/editorTheme";
import { RefreshCw } from "lucide-react";
import { cn } from "@/lib/utils";
export default function TextEditor({
  initialBlocks,
  onChange,
  className,
  editable = true,
  saveDataFn,
  placeholder = "Write or type press '/' cor commands...",
}) {
  const [isSaving, setIsSaving] = useState(false);

  // We use the English, default dictionary
  const locale = locales["en"];
  const editor = useCreateBlockNote({
    initialContent: initialBlocks || "",
    // We override the `placeholders` in our dictionary
    dictionary: {
      ...locale,
      placeholders: {
        ...locale.placeholders,
        // We override the default placeholder
        default: placeholder,
      },
    },
  });
  useEffect(() => {
    if (initialBlocks) {
      editor.replaceBlocks(editor.document, initialBlocks);
    }
  }, [initialBlocks, editor]);
  const debouncedSave = useCallback(
    debounce(async (content) => {
      if (editable) {
        setIsSaving(true); // Set saving status to true
        await saveDataFn(content);
        setIsSaving(false); // Set saving status to false after saving
      }
    }, 300),
    [saveDataFn, editable]
  );
  async function onEditorContentChange(editor) {
    if (saveDataFn) {
      await debouncedSave({ blocks: editor.document });
    }
  }
  return (
    <div className={cn("flex py-4 rounded-md w-full pl-4", className)}>
      <BlockNoteView
        editor={editor}
        onChange={onChange ? onChange : onEditorContentChange}
        editable={editable}
        theme={editorTheme}
        className={"task-description-editor w-full "}
      />
      {saveDataFn && (
        <div className="flex text-xs items-start justify-end gap-2 mr-4">
          <RefreshCw
            className={`w-3 h-3 ${
              isSaving ? "animate-spin" : "text-transparent"
            } `}
          />
        </div>
      )}
    </div>
  );
}
